import * as types from './GSAction_Type'
import { updateAlertError, updateLoader } from '../common/common_action'
import { GetRequest, PostRequestForFile, GetRequestCached2, GetRequestCachedV3, PostRequest, PostRequestCachedV3, PostRequestV2 } from '../../components/common/api'
import { urls } from '../../components/common/constants'
import { isNull } from '../../components/common/helper'

export const updateBookingConsType = (data) => {
  return { type: types.BOOKING_CONS_TYPE, data }
}
export const updateMopTableData = (data) => {
  return { type: types.MOP_TBL_DATA, data }
}
export const updateAutoDelTableData = (data) => {
  return { type: types.AUTO_Del_TBL_DATA, data }
}
export const updatePickUpAndDropOff = (data) => {
  return { type: types.PICKUP_AND_DROPOFF, data }
}
export const updateFocApprTableData = (data) => {
  return { type: types.FOC_APPR_LIST, data }
}
export const updateFocApprConsTypeData = (data) => {
  return { type: types.FOC_APPR_CONS_TYPE_DATA, data }
}
export const updateGsDocumentsCharge = (data) => {
  return { type: types.GS_DOCUMENTS_CHARGE, data }
}
export const updateGSBranchValuationDetailsTableData = (data) => {
  return { type: types.GS_VALUATION_CHARGE_TABLE, data }
}
export const updateGSEditValuationDetails = (data) => {
  return { type: types.GS_EDIT_VALUATION_CHARGE_DETAIL, data }
}
export const updateDestCityWithCrossingBranch = (data) => {
  return { type: types.DESTCITY_WITH_CROSSING_BRANCH, data }
}
export const updateCrossingCities = (data) => {
  return { type: types.CITY_LIST_F0R_CROSSING_MASTER, data }
}

export const updateAutoReceiveTblData = (data) => {
  return { type: types.AUTO_RECEIVE_TBL_DATA, data }
}

export const updateAutoBrnchTransRecvTblData = (data) => {
  return { type: types.AUTO_BRNCH_TRANS_RECV_TBL_DATA, data }
}

export const updateAutoBrnchTransRecvFilters = (data) => {
  return { type: types.AUTO_BRNCH_TRANS_RECV_FILTERS, data }
}
export const updatePaymentModeTableData = (data) => {
  return { type: types.PAYMENT_MODE_TABLEDATA, data }
}
export const updateMonthlyTargetTableData = (data) => {
  return { type: types.MONTHLY_TARGET_TABLE_DATA, data }
}

export const updateGSTValidation = (data) => {
  return { type: types.GST_VALIDATION_DATA, data }
}
export const updateGSTInvConfigData = (data) => {
  return { type: types.GST_INV_CONFIG_DATA, data }
}
export const updateServiceCityListALl = (data) => {
  return { type: types.SERVICE_TYPE_LIST_ALL_TABLE_DATA, data }
}

export const updateKgKmRateMatrixTblData = (data) => {
  return { type: types.KG_KM_RATE_MATRIX_DATA, data }
}
export const updateKgKmDocChrgTblData = (data) => {
  return { type: types.KG_KM_DOC_CHRG_DATA, data }
}
export const updateServiceTypeListAll = (data) => {
  return { type: types.SERVICE_TYPE_LIST_ALL_DATA, data }
}
export const updateServiceTypeListAll2 = (data) => {
  return { type: types.SERVICE_TYPE_LIST_ALL2_DATA, data }
}
export const updateKgKmRateMatrixHistoryTblData = (data) => {
  return { type: types.KG_KM_RATE_MATRIX_HISTORY_DATA, data }
}
export const updatePartyConfigTableData = (data) => {
  return { type: types.PARTY_CONFIG_TBL_DATA, data }
}
export const updateCargoCityList = (data) => {
  return { type: types.CARGO_CITY_LIST, data }
}
export const updatePartyMasterListAll = (data) => {
  return { type: types.PARTY_MASTER_LIST_ALL, data }
}

export const getBookingConsType = (data, isCache = false, cacheDuration = 0) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequestCachedV3(urls.getGSBookingConsType, data, isCache, cacheDuration)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateBookingConsType(res.Data))
      } else {
        dispatch(updateBookingConsType([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateBookingConsType([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
    })
}

export const bookingConsTypeTableData = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getGSBookingConsType, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const bookingCreateNewConsType = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getGSBCreateNewConsType, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getPickUpAndDropOff = (obj) => (dispatch) => {
  dispatch(updateLoader(true));
  GetRequest(urls.getPickUpAndDropOff, obj).then((res) => {
    dispatch(updateLoader(false))
    if (res.status === 'Success') {
      dispatch(updatePickUpAndDropOff(res.Data.Table))
    } else {
      dispatch(updatePickUpAndDropOff([]))
      dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
    }

  }).catch((error) => {
    dispatch(updateLoader(false))
    dispatch(updatePickUpAndDropOff([]))
    dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
  })
}

export const getPickupDropoffChargeSlab = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.getPickupDropoffChargeSlab, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const updatePickUpAndDropOffCharge = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.updatePickUpAndDropOffCharge, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const updateLabelList = (data) => ({
  type: types.Label_LIST,
  data,
})

export const updateTicketFormatList = (data) => ({
  type: types.TICKET_FORMAT_LIST,
  data,
})

export const getWeightChrg = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.getWeightChrg, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getDeliveryChrg = (obj,isCache=false,cacheDuration=0) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequestCachedV3(urls.getDeliveryChrg, obj,isCache,cacheDuration)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getDeliveryExtraHamaliChrg = (obj,isCache=false,cacheDuration=0) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequestCachedV3(urls.getDeliveryExtraHamaliChargeList, obj,isCache,cacheDuration)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const updateDeliveryChrg = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.updateDeliveryChrg, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const updateDeliveryExtraHamaliCharge = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.updateDeliveryExtraHamaliCharge, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getHamaliChrgListData = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.getHamaliChrgListData, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getBookingOperatorHamaliChargeList = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.getBookingOperatorHamaliChargeList, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const updateBookingHamaliChargeInsertUpdate = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.updateBookingHamaliChargeInsertUpdate, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const updateBookingOperatorHamaliChargeInsertUpdate = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.updateBookingOperatorHamaliChargeInsertUpdate, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}


export const getFocApprovalTableData = (data, isCache = false, cacheDuration = 0) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getFocApprTblData, data, isCache, cacheDuration)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateFocApprTableData(res?.Data?.Table))
      } else {
        dispatch(updateFocApprTableData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateFocApprTableData([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
    })
}

export const focApprAuthDataInsert = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getFocApprAuthInsert, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getFocApprConsTypeData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.getFocApprConsType, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateFocApprConsTypeData(res.Data))
      } else {
        dispatch(updateFocApprConsTypeData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateFocApprConsTypeData([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
    })
}
export const getMethodOfPkngTableData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getMopTblData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateMopTableData(res?.Data?.Table))
      } else {
        dispatch(updateMopTableData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateMopTableData([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
    })
}

export const methodOfPkngDataInsert = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getMopInsertUpdate, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getGSDocumentsCharge = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getGSDocumentCharges, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateGsDocumentsCharge(res.Data))
      } else {
        dispatch(updateGsDocumentsCharge([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateGsDocumentsCharge([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
    })
}
export const getGSDocumentChargeInsertUpdate = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getGSDocumentChargeInsertUpdate, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}


export const updateWeightChrg = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.updateWeightChrg, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const getDemurrageChrg = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.getDemurrageChrg, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const updateDemurrageChrg = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.updateDemurrageChrg, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getBranchAndCityList = (data, isCache = false, cacheDuration = 0) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequestCachedV3(urls.getBranchConfigOrEwbillinfo, data, isCache, cacheDuration)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getBranchPaymentTypeConfigDetails = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.getBranchPaymentTypeConfigDetails, data)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const getBranchPaymentTypeConfigUpdate = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getBranchPaymentTypeConfigUpdate, data)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getGSBranchValuationDetailsTableData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getGSBranchValuationDetailsTableData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateGSBranchValuationDetailsTableData(res.Data))
      } else {
        dispatch(updateGSBranchValuationDetailsTableData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateGSBranchValuationDetailsTableData([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
    })
}
export const getgetGSEditValuationDetails = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getGSEditValuationDetails, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateGSEditValuationDetails(res.Data))
      } else {
        dispatch(updateGSEditValuationDetails([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateGSEditValuationDetails([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
    })
}

export const getGSInsuranceInsertUpadate = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getGSInsuranceInsertUpadate, data)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}//auto delivery
export const getAutoDeliveryTableData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getAutoDeliveryTblData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateAutoDelTableData(res?.Data?.Table))
      } else {
        dispatch(updateAutoDelTableData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateAutoDelTableData([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
    })
}
//auto delivery aad, edit

export const updateAutoDelivery = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.updateAutoDelivery, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getAutoReceiveTableData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getAutoReceiveTblData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateAutoReceiveTblData(res?.Data?.Table))
      } else {
        dispatch(updateAutoReceiveTblData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateAutoReceiveTblData([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
    })
}

export const autoReceiveDataInsertUpdate = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getAutoReceiveInsertUpdate, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getAutoBrnchTransRecvTblData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getAutoTransactionTblData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateAutoBrnchTransRecvTblData(res?.Data?.Table))
      } else {
        dispatch(updateAutoBrnchTransRecvTblData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateAutoBrnchTransRecvTblData([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
    })
}

export const autoBrnchTransRecvInsertUpdate = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getAutoTransactionInsertUpdate, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const getAutoBrnchTransRecvFilters = (data, isCache = false, cacheDuration = 0) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequestCachedV3(urls.getAutoTransactionFilters, data, isCache, cacheDuration)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateAutoBrnchTransRecvFilters(res?.Data?.Table))
      } else {
        dispatch(updateAutoBrnchTransRecvFilters([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateAutoBrnchTransRecvFilters([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
    })
}
export const paymentModeDropData = (obj, isCache = false, cacheDuration = 0) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequestCachedV3(urls.getFranchiseeCompanyList, obj, isCache, cacheDuration)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getMonthlytargetTableData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getMonthlytargetTableData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateMonthlyTargetTableData(res?.Data?.Table))
      } else {
        dispatch(updateMonthlyTargetTableData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateMonthlyTargetTableData([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
    })
}

export const getMonthlyTargetUpdate = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getMonthlyTargetUpdate, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const getPaymentModeTableData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getGSPaymentModeTableData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updatePaymentModeTableData(res.Data))
      } else {
        dispatch(updatePaymentModeTableData([]))
        dispatch(updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updatePaymentModeTableData([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
    })
}
export const paymentModeSave = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getGSPaymentModeSave, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
//Ticket Format
export const getTicketLabelList = () => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getTicketLabelList)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateLabelList(res.Data.Table))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
  dispatch(updateLabelList([]))
}
export const getBranchesWithCargoTicketFormat = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.getBranchesWithCargoTicketFormat, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const AssignCargoTicketFormat = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.AssignCargoTicketFormat, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getCargoTicketFormatList = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getCargoTicketFormatList, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateTicketFormatList(res.Data.Table))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
  dispatch(updateTicketFormatList([]))
}
export const updateTicketFormat = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.updateTicketFormat, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getGSTValidation = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.validateGSTN, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'True' && isNull(res.error)) {
        dispatch(updateGSTValidation(res))
      } else {
        dispatch(updateGSTValidation({}))
        dispatch(updateAlertError({ show: true, msg: res.ErrMessage, nextId: 'gicGSTNo' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(updateGSTValidation({}))
      dispatch(updateAlertError({ show: true, msg: err, nextId: '' }))
    })
}
export const getGSTInvoiceConfigTblData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getGSTInvConfigData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateGSTInvConfigData(res))
      } else {
        dispatch(updateGSTInvConfigData({}))
        dispatch(updateAlertError({ show: true, msg: res.ErrMessage, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(updateGSTInvConfigData({}))
      dispatch(updateAlertError({ show: true, msg: err, nextId: '' }))
    })
}
export const gstInvoiceConfigUpdate = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.updateGSTInvoiceConfigData, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getCorporateRateMatrix = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.getCorporateRateMatrix, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const corporateRateMatrixInsertUpdate = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.corporateRateMatrixInsertUpdate, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getPartyWeightChrg = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.getPartyWeightChrg, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const updatePartyWeightChrg = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.updatePartyWeightChrg, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const GetDestCitiesWithCrossingBranch = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.GetDestCitiesWithCrossingBranch, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateDestCityWithCrossingBranch(res?.Data?.Table))
      } else {
        dispatch(updateDestCityWithCrossingBranch([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateDestCityWithCrossingBranch([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
    })
}

export const GetCitiesWithCrossingBranch = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.CityListForCrossingMaster, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateCrossingCities(res?.Data?.Table))
      } else {
        dispatch(updateCrossingCities([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateCrossingCities([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
    })
}
export const saveCrossingChanges = (data, successMsg = 'Updated Successfully') => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.CargoUpdateCrossingBranches, data)
    .then((res) => {
      dispatch(updateLoader(false))
      dispatch(updateAlertError({ show: true, msg: successMsg, success: true, nextId: '' }))
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateCrossingCities([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
    })
}
export const GetServiceTypeListAllTableData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.ServiceTypeListAllTableData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateServiceCityListALl(res?.Data?.Table))
      } else {
        dispatch(updateServiceCityListALl([]))
        dispatch(updateAlertError({ show: true, msg: res.ErrMessage, nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateServiceCityListALl([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
    })
}

export const serviceTypeInsertUpdate = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getServiceTypeInsertUpdate, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const uploadCrossingMasterFileData = (params,obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequestForFile(urls.uploadCrossingMasterFile,params, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const GetKgKmRateMatrixTblData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.kgKmRateMatrixTblData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateKgKmRateMatrixTblData(res?.Data))
        dispatch(updateKgKmDocChrgTblData(res?.Data?.Table1))
      } else {
        dispatch(updateKgKmRateMatrixTblData([]))
        dispatch(updateKgKmDocChrgTblData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateKgKmRateMatrixTblData([]))
      dispatch(updateKgKmDocChrgTblData([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
    })
}

export const getServiceTypeListAllData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getServiceTypeListAll, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateServiceTypeListAll(res?.Data?.Table))
        dispatch(updateServiceTypeListAll2(res?.Data?.Table1))
      } else {
        dispatch(updateServiceTypeListAll([]))
        dispatch(updateServiceTypeListAll2([]))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateServiceTypeListAll([]))
      dispatch(updateServiceTypeListAll2([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
    })
}

export const kgKmRateMatrixUpdate = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.kgKmRateMatrixUpdateTblData, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const uploadKgKmRateMatrixFileData = (params,obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequestForFile(urls.kgKmRatematrixUploadFile,params, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getKgKmRateFileUploadStatus = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.kgKmFileUploadStatus, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getKgKmRateFileUploadCancel = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.kgKmFileUploadCancel, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const GetKgKmRateMatrixHistoryTblData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.kgKmRatematrixHistoryTblData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        if (res?.Data?.Table.length > 0) {
          dispatch(updateKgKmRateMatrixHistoryTblData(res?.Data?.Table))
        } else {
          dispatch(updateKgKmRateMatrixHistoryTblData([]))
        }
      } else {
        dispatch(updateKgKmRateMatrixHistoryTblData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateKgKmRateMatrixHistoryTblData([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
    })
}
export const getPartyConfigTableData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.getPartyList, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updatePartyConfigTableData(res?.Data))
      } else {
        dispatch(updatePartyConfigTableData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updatePartyConfigTableData([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
    })
}

export const partyConfigInsertUpdate = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getPartyMasterInsertUpdate, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getRateMatrixData = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.getRateMatrixData, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const validateGSTNumber = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.validateGSTN, data)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getPartyRateMatrixTableData = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.getPartyRateMatrixData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      return resolve(res)
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      reject(error)
    })
})
}
export const updateRateMatrixUpdate = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.updateRateMatrixUpdate, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getParyRateUpdate = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getPartyRateMatrixUpdate, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const getParyMasterRateUpload = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getPartyRatesUpload, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}




export const getCityPairRateMatrixData = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.cityPairRateMatrixData, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const updateCityPairRateMatrixData = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.updateCityPairRate, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const uploadCityPairRateMatrixFileData = (params,obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequestForFile(urls.uploadCityPairRateFile,params, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const getCityPairFileUploadStatus = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.cityPairFileUploadStatus, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const cancelCityPairStatus = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.cancelRateMasterStatus, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getViewRateMatrixTableData = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.getViewRateMatrixDetails, data)
    .then((res) => {
      dispatch(updateLoader(false))
      return resolve(res)
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      reject(error)
    })
})
}
export const getCargoCompanyCitiesList = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getCityList, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateCargoCityList(res?.Data?.Table))
      } else {
        dispatch(updateCargoCityList([]))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateCargoCityList([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
    })
}

export const getPartyMasterListAllData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getPartyMasterListAll, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        if (res?.Data?.Table.length > 0) {
          dispatch(updatePartyMasterListAll(res?.Data))
        } else {
          dispatch(updatePartyMasterListAll([]))
        }
      } else {
        dispatch(updatePartyMasterListAll([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updatePartyMasterListAll([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
    })
}

export const getCityPairRateMatrixExcelData = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.cityPairRateMatrixExcelData, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}